export class DataService{
   public  dataFromService:any;

     
     }



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/DatapassService.ts